import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { useRowTabIndex } from './row-tab-stop';
import { jsx as _jsx } from "react/jsx-runtime";
// A native range input cannot style the part of the track before the thumb,
// so the fill is the input's own background: a two-stop gradient in the brand
// colour and a 10 % black overlay, split at the value and moved by one CSS
// variable. No thumb; the split marks the position.
var TRACK = 'h-1 w-full appearance-none overflow-hidden rounded-full border-transparent bg-[linear-gradient(to_right,var(--color-main)_var(--progress),rgb(0_0_0/10%)_var(--progress))] enabled:cursor-pointer [&::-moz-range-thumb]:size-0 [&::-moz-range-thumb]:border-0 [&::-moz-range-track]:bg-transparent [&::-webkit-slider-thumb]:size-0 [&::-webkit-slider-thumb]:appearance-none';
var RangeSlider = function RangeSlider(_ref) {
  var handleChange = _ref.handleChange,
    preferredValue = _ref.preferredValue,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    ariaValueText = _ref.ariaValueText,
    ariaLabel = _ref.ariaLabel,
    className = _ref.className,
    style = _ref.style,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    step = _ref.step;
  // In a list row that does not hold the list's Tab stop, the slider is out
  // of the Tab order.
  var rowTabIndex = useRowTabIndex();
  var progress = max > min ? Math.min(100, Math.max(0, (preferredValue - min) / (max - min) * 100)) : 0;
  return /*#__PURE__*/_jsx("input", {
    value: preferredValue,
    onChange: handleChange,
    type: "range",
    className: twMerge(TRACK, className),
    style: _objectSpread({
      '--progress': "".concat(progress, "%")
    }, style),
    disabled: disabled,
    tabIndex: rowTabIndex,
    min: min,
    max: max,
    step: step
    // No aria-valuemin/max/now or aria-orientation: the native input
    // publishes its own, and a hand-written aria-valuenow would carry the
    // raw prop where the browser has already snapped the value to the
    // step.
    ,
    "aria-valuetext": ariaValueText,
    "aria-label": ariaLabel
  });
};
export default RangeSlider;